const doc = [({"en":({"js":({"models_table":({"columns_drop_down":({"columns":"Columns"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;